import { apiRequest } from "./client";

export const usersApi = {
  list(params = {}) {
    const search = new URLSearchParams();
    if (params.status) search.set("status", params.status);
    const query = search.toString();
    return apiRequest(`/users${query ? `?${query}` : ""}`);
  },

  approve(userId, payload = {}) {
    return apiRequest(`/users/${userId}/approve`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  suspend(userId) {
    return apiRequest(`/users/${userId}/suspend`, {
      method: "PATCH",
    });
  },
};
